// YearPanel.js — Panneau gauche : année + événements exacts + CTA si vide

import React from 'react';
import { CATEGORIES, formatYear } from '../data/events';

export function YearPanel({ year, events, onEventClick, onAddEvent, isLoggedIn }) {
  const isBC    = year < 0;
  const absYear = Math.abs(Math.round(year));
  const era     = isBC ? 'av. J.-C.' : 'ap. J.-C.';

  // Événements de l'année EXACTE uniquement
  const exactEvents = events.filter(ev => ev.year === Math.round(year));

  return (
    <div className="year-panel">

      {/* ── Année en grand ── */}
      <div className="yp-year-block">
        <div className="yp-year-number">{absYear}</div>
        <div className="yp-year-era">{era}</div>
        <div className="yp-year-divider" />
      </div>

      {/* ── Liste ou CTA ── */}
      {exactEvents.length > 0 ? (
        <>
          <div className="yp-events-label">
            {exactEvents.length} événement{exactEvents.length > 1 ? 's' : ''} cette année
          </div>
          <div className="yp-events-list">
            {exactEvents.map(ev => {
              const cat = CATEGORIES[ev.category];
              return (
                <button
                  key={ev.id}
                  className="yp-event-item"
                  onClick={() => onEventClick(ev)}
                  style={{ '--cat-color': cat.color }}
                >
                  <div className="yp-event-left">
                    <span className="yp-event-icon">{cat.icon}</span>
                  </div>
                  <div className="yp-event-content">
                    <span className="yp-event-year" style={{ color: cat.color }}>
                      {formatYear(ev.year)}
                    </span>
                    <span className="yp-event-title">{ev.title}</span>
                    <span className="yp-event-cat">{cat.label}</span>
                  </div>
                  <span className="yp-event-arrow">→</span>
                </button>
              );
            })}
          </div>
        </>
      ) : (
        <div className="yp-empty-block">
          <p className="yp-empty-text">
            Aucun événement<br />recensé en {absYear} {era}.
          </p>
          <button
            className="yp-add-btn"
            onClick={onAddEvent}
          >
            <span>✚</span>
            {isLoggedIn ? 'Ajouter un événement' : 'Contribuer à cette année'}
          </button>
        </div>
      )}
    </div>
  );
}
